module.exports = __webpack_public_path__ + "img/mw.42dce3a5.svg";